import {
  Component,
  OnInit,
  Inject,
  ChangeDetectionStrategy
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FolderService } from 'src/app/shared/folder.service';
import { UtilsService } from '../../shared/utils.service';
import { RBACService } from '../../shared/rbac.service';
import { DocumentPermissions } from '../../interfaces/document-permissions.interface';

@Component({
  selector: 'app-template-docs-view',
  templateUrl: './template-docs-view.component.html',
  styleUrls: ['./template-docs-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class TemplateDocsViewComponent implements OnInit {
  permissions: DocumentPermissions;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<TemplateDocsViewComponent>,
    private folderService: FolderService,
    public utils: UtilsService,
    private rbac: RBACService
  ) {
    // Get permissions from dialog data with default fallback
    this.permissions = data.permissions || {
      feature: '',
      canCreate: false,
      canEdit: false,
      canDelete: false
    };
  }

  ngOnInit() {
    // Build view permissions based on the feature context
    const feature =
      this.permissions.feature || RBACService.RBAC_F.F_TEMPLATES_DOCUMENTS;
    const viewPermissions: string[] = [];

    // User profile context: use core permission instead of feature-specific permissions
    if (feature === 'user_profile') {
      viewPermissions.push(RBACService.RBAC_F.CORE_PERMISSION_USER_PROFILE);
    } else {
      // Site documents require sites:view as a parent permission
      if (feature === RBACService.RBAC_F.F_SITES_DOCUMENTS) {
        viewPermissions.push(
          RBACService.getPermission(
            RBACService.RBAC_F.F_SITES,
            RBACService.RBAC_A.A_VIEW
          )
        );
      }

      // Employee documents require employees:view as a parent permission
      if (feature === RBACService.RBAC_F.F_EMPLOYEES_TRAINING_COMPETENCIES) {
        viewPermissions.push(
          RBACService.getPermission(
            RBACService.RBAC_F.F_EMPLOYEES,
            RBACService.RBAC_A.A_VIEW
          )
        );
      }

      // Add the feature-specific view permission
      viewPermissions.push(
        RBACService.getPermission(feature, RBACService.RBAC_A.A_VIEW)
      );
    }

    if (!this.rbac.userCanAccess(viewPermissions, true)) {
      this.rbac.showGenericAccessDeniedMessage(
        `You do not have permission to view this document.`
      );
      this.dialogRef.close();
      return;
    }

    this.folderService
      .find(this.data.folder.id)
      .subscribe((response) => (this.data.folder = response.data));
  }

  view(url: string) {
    window.open(url, '_blank');
  }

  // Expose RBACService to template
  protected readonly RBACService = RBACService;
}
